import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import React from 'react';

import { ViewSwitcherToggleProps, ViewType } from './types';

const ViewSwitcherToggleImpl: React.FC<ViewSwitcherToggleProps> = ({
  value,
  onChange,
  cardLabel = 'Card',
  tableLabel = 'Table',
  className,
}) => {
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: ViewType | null
  ) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="view type"
      className={className}
    >
      <ToggleButton value="card" aria-label="card view">
        {cardLabel}
      </ToggleButton>
      <ToggleButton value="table" aria-label="table view">
        {tableLabel}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export const ViewSwitcherToggle = styled(ViewSwitcherToggleImpl)(
  ({ theme }) => css`
    /* Add any custom styling if needed */
  `
);
